import * as React from 'react';
import { MarketplaceRouter } from '../marketplace-router';
import { MarketplaceMenu } from '../marketplace-menu';
import s from './marketplace-layout.scss';
import { composer } from '../../component-decorators/composer';
import { config } from '../../config';
import { Origin } from '../..';
import { useConfigContext } from '../../config-context';
export var MarketplaceLayout = composer()
    .withMarketplaceStore()
    .withExperiments()
    .compose(function (_a) {
    var hideSearchInMenu = _a.hideSearchInMenu, marketplaceStore = _a.marketplaceStore, experiments = _a.experiments;
    var isInStandaloneMarket = config.origin === Origin.STANDALONE;
    var minHeight = isInStandaloneMarket ? 'calc(100vh - 60px)' : '100%';
    console.log("marketplace-component/src/components/marketplace-layout/marketplace-layout.tsx file - line 29 - " + Date.now());
    var showHolidaySale = experiments.enabled('specs.marketplace.blackFridaySale');
    // tslint:disable-next-line:react-hooks-nesting
    var _b = useConfigContext(), isMobile = _b.isMobile, locale = _b.locale;
    return (React.createElement("div", { "data-testid": "marketplace-layout", className: s.marketplaceLayout, style: { minHeight: minHeight } },
        !marketplaceStore.route.hideMenu && (React.createElement(MarketplaceMenu, { hideSearchInMenu: hideSearchInMenu, experiments: experiments })),
        React.createElement(MarketplaceRouter, { showHolidaySale: showHolidaySale })));
});
//# sourceMappingURL=marketplace-layout.js.map